import { styled } from '@mui/material';

export const StyledCarouselActionWrapper = styled('div')(
	({
		theme: {
			palette: { sizes },
		},
	}) => ({ padding: `${sizes.size_2}px 0`, textAlign: 'center' }),
);
